import React from 'react'
import Layout from '../SectionLayout/layout'
import SectionTitle from '../../components/section_title/section_title'
import Reason from './reason/Reason'

import icon_a from '../../assets/icon_a.png'
import icon_b from '../../assets/icon_b.png'
import icon_c from '../../assets/icon_c.png'
import icon_d from '../../assets/icon_d.png'

import JSONconfig from '../../config'

import './whyuse3d.scss'

function WhyUse3D() {
  return <Layout>
    <div className="WhyUse3D">
      <SectionTitle subtitle="3D互动展销已成为商品展示的必然趋势" type="black">为什么升级3D</SectionTitle>
      <div className="reason_show_container">
        <iframe className="iframe" name="drill" sandbox="allow-scripts allow-same-origin allow-popups allow-forms" frameBorder="0" src={JSONconfig.iframe}></iframe>
        <div className="reasons_container">
          <Reason icon={icon_a} title="3D全维度互动" subtitle="720°旋转缩放, 立体直观展示商品"></Reason>
          <Reason icon={icon_b} title={`"照片级"真实感`} subtitle="材质细节清晰可见"></Reason>
          <Reason icon={icon_c} title="高品质动态传达卖点价值" subtitle="吸引用户长时间停留, 加深浏览印象"></Reason>
          <Reason icon={icon_d} title="全端用户行为数据采集" subtitle="多维数据分析, 为用户运营提供数据支持"></Reason>
        </div>
      </div>
    </div>
  </Layout>
}

export default WhyUse3D
